import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Dialog, Dropdown, Loader, toastMessage, Checkbox, Switcher } from "../utils/index";
import { buttonClasses } from "../utils/theme";
import { capitalizeCamelCase, capitalizeSentence, findDeepValue, flattenObj, formatDate, isFilePath, parseUnderscore, removeSpecialChars } from "../../services/functions";
import { useGetOrgSettingQuery, useUpdateOrgSettingMutation } from "../../api/vmsSlice";
import { useCheckpoints, useUserDetail } from "../../services/hooks";
import Draggable from "react-draggable";
import { Resizable } from "re-resizable";
import Barcode from "react-barcode";
import QRCode from "qrcode.react";
import ReactToPrint from "react-to-print";
import LynkIdlogo from "../../LynkIdlogo.png";
import FilePreview from "../utils/FilePreview";
import { useParams } from "react-router-dom";

const labelData = {
	border: "5px solid #8a8686",
	allFields: [
		{
			type: "logo",
			fieldName: "Show Logo",
			x: 6,
			y: 36,
			width: 120,
			height: 40,
			padding: 5,
			style: {
				width: "100%",
				height: "40px",
			},
			disabled: false,
		},
		{
			type: "name",
			x: 61,
			fieldName: "Show Company",
			y: 35,
			width: 268,
			height: 40,
			padding: 5,
			disabled: false,
			style: {
				fontWeight: "800",
				lineHeight: "20px",
				fontSize: "18px",
				color: "#000000",
			},
		},
		{
			type: "itemDetail",
			x: 0,
			fieldName: "Show Detail",
			y: 0,
			width: 300,
			padding: 5,
			multiline: false,
			subItems: [],
			disabled: false,
		},
		{
			type: "qr",
			x: 54,
			fieldName: "Label Type",
			y: 30,
			width: 60,
			height: 60,
			disabled: false,
			dynamicDetail: "1",
			qrType: "qrCode",
		},
	],
	fieldsConfig: {
		top: {
			style: {
				display: "flex",
				justifyContent: "space-between",
				height: "100",
				border: "1px solid black",
				position:"relative"
			},
		},
		content: {
			style: {
				display: "flex",
				justifyContent: "space-between",
			},
		},
	},
	width: "100%",
	// "height": "500px",
	height: "auto",
	style: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "start",
		border: "2px solid grey",
	},
	label: "Inventory 1",
	showBorder: false,
};
let keyMap = {
	companyName: "name",
	logo: "logo",
	barCode: "qr",
	qrCode: "qr",
};
let propMap = {
	companyName: "disabled",
	logo: "disabled",
	barCode: "qrType",
	qrCode: "qrType",
};
export default function PrintLabel({ open, onClose, detailData, detailTableHeaders }) {
	const componentRef = useRef();
	const { userDetail } = useUserDetail();
	const [labelDetail, setLabelDetail] = useState({...labelData, companyName: userDetail?.orgName || ''});
	const [previewForPrint, setPreviewForPrint] = useState(true);
	const [readyForPrint, setReadyForPrint] = useState(true);
	const [updateOrgSetting] = useUpdateOrgSettingMutation();
	const [selection, setSelection] = useState({
		labelType: "qrCode",
		companyName: true,
		logo: true,
		defaultFilter: true,
		// resetFilter: false,
	});
	const { type, number } = useParams();
	const { checkpoints } = useCheckpoints();
	const currentCheckpoint = checkpoints.find((_) => (number ? _.checkpointType == type && _.checkpointNumber == number : _.checkpointType == type)) || {};
	const { _id: checkpointId} = currentCheckpoint;
	
	const { data, isFetching, isLoading } = useGetOrgSettingQuery({ fields : [`pdfLayoutSettings.${checkpointId}`,"pdfSettings", "prefixArray" ]}, { refetchOnMountOrArgChange: true });
	let { data: orgSetting = {} } = data || { data: {} };

	const [filterData, setFilterData] = useState(processedData(detailData, detailTableHeaders, orgSetting?.pdfSettings?.default_fields || []));
	// console.table(JSON.stringify(detailData))
	// console.log(detailTableHeaders);

	// console.log('filter', detailData?.trip_counter)
	const handlefilter = (name, value) => {
    let _name, _value;
    if (["barCode", "qrCode"].includes(name)) {
        _name = "labelType";
        _value = name;
    } else {
        _name = name;
        _value = value;
    }
    
    setSelection((prevState) => ({ ...prevState, [_name]: _value }));
    
		if (["companyName", "logo", "barCode", "qrCode"].includes(name)) {
			setLabelDetail((prevElements) => {
				return {
					...prevElements,
					allFields: prevElements.allFields?.map((ele) => {
						if (ele.type === keyMap[name]) {
							return {
								...ele,
								[propMap[name]]: ["barCode", "qrCode"].includes(name) ? name : !value
							};
						}
						return ele;
					}),
				};
			});
		}
	};

	const handleEdit = () => {
		// console.log('editt')
		// console.log(labelDetail);
		// console.log(filterData?.allFields)
		setReadyForPrint(true);
		setLabelDetail((prevElements) => {
			let newElements = { ...prevElements };
			newElements = {
				...newElements,
				allFields: newElements?.allFields.map((ele, index) => {
					if (ele.type === "itemDetail") {
						newElements.allFields[index].subItems = filterData?.allFields ;
					}
					return ele;
				}),
			};
			return newElements;
		});
	};

	const handlePreview = () => {
		// console.log('preview')
		setPreviewForPrint(true);
		// setReadyForPrint(true);
	};

	const handleCancel = () => {
		if (readyForPrint) {
			setReadyForPrint(false);
			// setLabelDetail(labelData);
		}
		if (previewForPrint) {
			setPreviewForPrint(false);
		}
		if (!readyForPrint && !previewForPrint) {
			// setLabelDetail(labelData);
			onClose();
		}
	};


	
useEffect(() => {
	if (!isLoading) {        
	  let dataProcessed = processedData(
		detailData, 
		detailTableHeaders, 
		orgSetting?.pdfSettings?.default_fields || [], 
		selection.defaultFilter, 
		data?.data?.pdfLayoutSettings?.[checkpointId]?.allFields?.[2]?.subItems
	  );
	  
	  setFilterData(dataProcessed);
	  
	  setLabelDetail((prevElements) => {
		// const newElements = { ...prevElements };
		const savedSettings = data?.data?.pdfLayoutSettings?.[checkpointId];
		const newElements = { 
			...prevElements,
			...(savedSettings || {}),
			width: savedSettings?.width || prevElements.width // Use saved width or default
		};
		// Always set the subItems from dataProcessed if available
		newElements.allFields = prevElements.allFields.map((ele, index) => {
		  if (ele?.type === "itemDetail") {
			return {
			  ...ele,
			  subItems: dataProcessed?.allFields || []
			};
		  }
		if (ele?.type === "logo" && savedSettings?.allFields?.[0]) {
			return savedSettings.allFields[0];
			}
			if (ele?.type === "name" && savedSettings?.allFields?.[1]) {
			return savedSettings.allFields[1];
			} 
			if (ele.type === "qr" && savedSettings?.allFields?.[3]) {
			return savedSettings.allFields[3];
			}
			return ele;
		});
		
		return newElements;
		});
	}
	}, [isLoading, selection?.defaultFilter, data, checkpointId]);


useEffect(() => {
	if (detailData?.trip_counter && userDetail) {
	  setLabelDetail(prev => ({
		...prev, 
		companyName: userDetail.orgName,
		allFields: prev.allFields.map(field => {
		  if (field.type === "qr") {
			return {
			  ...field,
			  dynamicDetail: detailData.trip_counter.toString() 
			};
		  }
		  return field; 
		})
	  }));
	}
  }, [detailData?.trip_counter, userDetail]);

	const savePrintData = async() => {
		// Create a deep copy of the settings
		const printDataCopy = JSON.parse(JSON.stringify(labelDetail));
		const pdfSettingsCopy = JSON.parse(JSON.stringify(orgSetting?.pdfSettings || {}));

	// Filter out unchecked items from subItems in layout settings
	if (printDataCopy?.allFields?.[2]?.subItems) {
		printDataCopy.allFields[2].subItems = printDataCopy.allFields[2].subItems.map(section => {
		return {
			...section,
			fields: section.fields.filter(field => field.isChecked)
		};
		}).filter(section => section.fields.length > 0);
	}

	// Update pdfSettings with the current default fields configuration
	if (!pdfSettingsCopy.default_fields) {
		pdfSettingsCopy.default_fields = [];
	}

	// Update the default fields in pdfSettings
	pdfSettingsCopy.default_fields = filterData.allFields.map(section => ({
		checkpointId: section.checkpointId,
		displayName: section.displayName,
		fields: section.fields.map(field => ({
		label: field.label,
		isChecked: field.isChecked
		}))
	}));

	printDataCopy.width = typeof printDataCopy.width === 'string' ? parseInt(printDataCopy.width, 10) : printDataCopy.width;
	
	const payload = {
		checkpointId: checkpointId,
		pdfLayoutSettings: printDataCopy,
		pdfSettings: pdfSettingsCopy  
	};
	
		await updateOrgSetting(payload)
			.unwrap()
			.then((res) => {
				if(res.error) 
				{
					toastMessage(false, res.message);
				} 
				else 
				{
					toastMessage(true, res.message);
				}
			})
			.catch((err) => {
				console.log(err);
				toastMessage(false, "Error in updating print label");
			});
	}

	return (
		<Dialog
			size="md"
			open={true}
			handleSubmit={() => (!readyForPrint ? handleEdit() : handlePreview())}
			handleClose={() => {
				// setLabelDetail(labelData);
				onClose();
			}}
			handleCancel={() => handleCancel()}
			title={"Generate and Print Labels"}
			noBtn={previewForPrint}
			SubmitText={!readyForPrint ? "Edit for Print" : "Preview before Print"}
		>
			{!readyForPrint ? (
				<div className="print_selection_container">
					<div className="level_1">
						<Checkbox
							id={"defaultFilter"}
							name={"defaultFilter"}
							checked={selection?.defaultFilter}
							label="Reset Filter"
							onChange={(e) => {
								handlefilter(e.target.name, e.target.checked);
							}}
						/>
						<Checkbox
							id={"barcode"}
							name={"barCode"}
							checked={selection?.labelType === "barCode" ? true : false}
							label="Bar Code"
							onChange={(e) => {
								handlefilter(e.target.name, e.target.checked);
							}}
						/>
						<Checkbox
							id={"qrcode"}
							name={"qrCode"}
							checked={selection?.labelType === "qrCode" ? true : false}
							label="QR Code"
							onChange={(e) => {
								handlefilter(e.target.name, e.target.checked);
							}}
						/>
						<Checkbox
							id={"logo"}
							name={"logo"}
							checked={selection?.logo}
							label="Show Logo"
							onChange={(e) => {
								handlefilter(e.target.name, e.target.checked);
							}}
						/>
						<Checkbox
							id={"companyName"}
							name={"companyName"}
							checked={selection?.companyName}
							label="Show Company Name"
							onChange={(e) => {
								handlefilter(e.target.name, e.target.checked);
							}}
						/>
					</div>
					{filterData?.allFields.map((ele) => (
						<div key={ele.displayName}>
							<div className="level_heading">
								<Checkbox
									id={ele.displayName}
									name={ele.displayName}
									checked={ele?.fields?.every((ele) => ele.isChecked) ? true : false}
									label={ele.displayName}
									onChange={(e) => {
										// console.log('ele', ele)
										setFilterData((prevState) => ({
											...prevState,
											allFields: prevState.allFields.map((item) => {
												if (item.displayName === ele.displayName) {
													return {
														...item,
														fields: item.fields.map((fieldItem) => {
															return { ...fieldItem, isChecked: e.target.checked };
														}),
													};
												}
												return item;
											}),
										}));
									}}
								/>
							</div>
							<div className="level_1">
								{ele?.fields.map((el) => (
									<div style={{ width: "260px" }} key={el.label}>
										<Checkbox
											id={el.label}
											name={el.label}
											checked={el.isChecked}
											label={el.label}
											onChange={(e) => {
												setFilterData((prevState) => ({
													...prevState,
													allFields: prevState.allFields.map((item) => {
														if (item.displayName === ele.displayName) {
															return {
																...item,
																fields: item.fields.map((fieldItem) => {
																	if (fieldItem.label === e.target.name) {
																		return { ...fieldItem, isChecked: e.target.checked };
																	}
																	return fieldItem;
																}),
															};
														}
														return item;
													}),
												}));
											}}
										/>
									</div>
								))}
							</div>
						</div>
					))}
				</div>
			) : null}
			{readyForPrint && (
				<div ref={componentRef} id="toPrint" style={{ border: "1px solid transparent", padding: "20px" }}>
					<Resizable
						style={{ border: (labelDetail.showBorder && "1px solid #FF2700") || "", ...(labelDetail.style || {}), position:"relative" }}
						size={{
							width: labelDetail.width || 500,
							height: labelDetail.height || "auto",
						}}
						onResizeStop={(e, direction, ref, d) => {
							setLabelDetail((prevElements) => ({
							...prevElements,
							width: prevElements.width + d.width,
							height: prevElements.height + d.height,
							}));
						}}
						minWidth={300} // Set minimum width
						maxWidth={800} // Set maximum width
					>
						<Resizable
							style={{ border: `2px solid black`, padding:  "", zIndex:'999' , display: "flex", justifyContent:"spaceBetween", flexWrap:"wrap"}}
							size={{ width: `${labelDetail.fieldsConfig.top.style.width}`, height: labelDetail.fieldsConfig.top.style.height}}
							onResizeStop={(e, direction, ref, d) =>{
								{
									setLabelDetail((prev) => {
										return (
											{
											...prev,
											fieldsConfig: {
												...prev.fieldsConfig,
												top: {
													style: {
														...prev.fieldsConfig.top.style,
														height: `${parseInt(prev.fieldsConfig.top.style.height) + d.height}px`,
													},
												},	
											},
										}
										)
									});

								}}}
						>
							{labelDetail?.allFields?.map((element, index) => {
								if (!element.disabled && ["qr", "logo", "name"].includes(element.type)) {
									return <RenderElement element={element} index={index} labelDetail={labelDetail} setLabelDetail={setLabelDetail} disabledDrag={previewForPrint} />;
								}
							})} 
							<div></div>
						</Resizable>
						{/* <hr className="bgg" /> */}
						<div className="content" style={labelDetail?.fieldsConfig?.content?.style || {}}>
							{labelDetail?.allFields?.map((element, index) => {
								if (!element.disabled && element.type === "itemDetail") {
									// if(element.subItems){
										return <RenderElement element={element} index={index} labelDetail={labelDetail} setLabelDetail={setLabelDetail} disabledDrag={previewForPrint} />;
									// }
									// else{
									// 	return <RenderElement element={filterData.allFields} index={index} labelDetail={labelDetail} setLabelDetail={setLabelDetail} disabledDrag={previewForPrint} />;
									// }
									
								}
							})}
						</div>
						{/* <div className="footer">
                    {labelDetail?.allFields?.map((element, index) => {
                        if (!element.disabled && element.type === 'signature') {
                            return renderElement(element, index, labelDetail, setLabelDetail);
                        }
                    })}
                </div> */}
					</Resizable>
				</div>
			)}
			{previewForPrint && (
				<div className="print-btn">
					<Button style={{ ...buttonClasses.lynkitOrangeEmpty, width: "fitContent" }} onClick={() => setPreviewForPrint(false)}>
						Back
					</Button>
					<ReactToPrint
						documentTitle="Label"
						onAfterPrint={() => setReadyForPrint(true)}
						onBeforeGetContent={savePrintData}
						// bodyClass="adjustContent"
						removeAfterPrint
						trigger={() => <Button style={{ ...buttonClasses.lynkitOrangeFill, width: "fitContent" }}>Print</Button>}
						content={() => componentRef.current}
					/>
				</div>
			)}
		</Dialog>
	);
}

const RenderElement = ({ element, index, labelDetail, setLabelDetail, disabledDrag = false }) => {
	const [enableParentDrag, setEnableParentDrag] = useState("");

	const handleDrag = (x, y) => {
		setLabelDetail((prevElements) => {
			const newElements = { ...prevElements };
			newElements["allFields"][index] = {
				...element,
				x,
				y,
			};
			return newElements;
		});
	};

	const handleResize = (d) => {
		// console.log(d);
		setLabelDetail((prevElements) => {
			const newElements = { ...prevElements };
			newElements["allFields"][index] = {
				...element,
				width: element.width + d.width,
				height: element.height + d.height,
			};
			return newElements;
		});
	};

	const renderContent = () => {
		switch (element.type) {
			case "logo":
				return (
					<>
						{!disabledDrag && (
							<div className="drag-container" onMouseEnter={() => setEnableParentDrag(element.type)} onMouseLeave={() => setEnableParentDrag("")}>
								{pepicon()}
							</div>
						)}
						<div className="logo">
							<img src={localStorage.getItem("logo") || LynkIdlogo} width={element?.style?.width || "inherit"} height={element?.style?.height || "inherit"} alt="Logo" />
						</div>
					</>
				);
			case "name":
				return (
					<>
						{!disabledDrag && (
							<div className="drag-container" onMouseEnter={() => setEnableParentDrag(element.type)} onMouseLeave={() => setEnableParentDrag("")}>
								{pepicon()}
							</div>
						)}
						<div
							className="name"
							style={
								element.style || {
									fontWeight: "bold",
									fontSize: "18px",
									color: "#000000",
								}
							}
						>
							{labelDetail?.companyName}
						</div>
					</>
				);

			case "itemDetail":
				return (
					<Resizable
					style={{ border: `${!disabledDrag ? "none" : "none"}`, padding: element.padding || "" }}
					size={{ width: "100%", height: element.height }}
					onResizeStop={(e, direction, ref, d) => handleResize(d)}
					>
					{element.subItems
						.filter(parentElement => 
						parentElement?.fields?.some(field => field.isChecked)
						)
						.map((parentElement, parentIndex) => (
						<Draggable
						key={parentIndex}
						defaultPosition={{ x: element.x, y: element.y }}
						onDrag={(e, { x, y }) => {
							e.stopPropagation();
							handleDrag(x, y);
						}}
						disabled={disabledDrag ? true : enableParentDrag === parentIndex ? false : true}
						>
						<Resizable
							style={{
							border: `${!disabledDrag ? "2px dotted rgb(202, 207, 191)" : "2px dotted transparent"}`,
							marginBottom: "15px",
							borderRadius: "10px",
							position: "relative",
							padding: `5px 5px 5px 20px` || "",
							}}
							size={{ width: "100%", height: element.height }}
							onResizeStop={(e, direction, ref, d) => handleResize(d)}
						>
							{!disabledDrag && (
							<div className="drag-container" onMouseEnter={() => setEnableParentDrag(parentIndex)} onMouseLeave={() => setEnableParentDrag("")}>
								{pepicon()}
							</div>
							)}
							<h4 style={{ fontSize: "18px" }}>{parentElement.displayName}</h4>
							<hr />
							<div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
							{parentElement.fields
								.filter(field => field.isChecked)
								.map((detailElement, detailIndex) => (
									<Draggable
									key={`${parentIndex}-${detailIndex}`}
									defaultPosition={{ x: detailElement.x, y: detailElement.y }}
									onDrag={(e, { x, y }) => {
										e.stopPropagation();
										setLabelDetail((prevElements) => {
										const newElements = { ...prevElements };
										newElements.allFields = newElements.allFields.map((field, fieldIndex) => {
											if (fieldIndex === index && field.type === "itemDetail") {
											return {
												...field,
												subItems: field.subItems.map((subItem, subItemIndex) => {
												if (subItemIndex === parentIndex) {
													return {
													...subItem,
													fields: subItem.fields.map((f, fIndex) => {
														if (fIndex === detailIndex) {
														return { ...f, x, y };
														}
														return f;
													}),
													};
												}
												return subItem;
												}),
											};
											}
											return field;
										});
										return newElements;
										});
									}}
									disabled={disabledDrag}
									>
									<div
										style={{
										color: "#000000",
										border: `${!disabledDrag ? "2px dotted rgb(202, 207, 191)" : "2px dotted transparent"}`,
										cursor: "pointer",
										}}
									>
										<span style={{ fontSize: "14px", fontWeight: "bold" }}>{parseUnderscore(capitalizeCamelCase(detailElement.label))} : </span>
										{isFilePath(String(detailElement.value)) ? (
										<FilePreview fileKey={detailElement.value} extension={String(detailElement.value)?.split(".").pop()} />
										) : (
										<span style={{ fontSize: "10px" }}>{detailElement.value || "-"}</span>
										)}
									</div>
									</Draggable>
								)
							)}
							</div>
						</Resizable>
						</Draggable>
					)
					)}
				</Resizable>
			);
			case "qr":
				return (
					<>
						{!disabledDrag && (
							<div className="drag-container" onMouseEnter={() => setEnableParentDrag(element.type)} onMouseLeave={() => setEnableParentDrag("")}>
								{pepicon()}
							</div>
						)}
						<div className="qr">
							{element.qrType === "qrCode" ? (
								<QRCode
									value={getEncodingData(element.dynamicDetail)}
									style={{
										left: `${element.x}px`,
										top: `${element.y}px`,
										width: `${element.width}px`,
										height: `${element.height}px`
									}}
								/>
							) : (
								<Barcode value={getEncodingData(element.dynamicDetail)} width={1} height={element.height} displayValue={false} />
							)}
						</div>
					</>
				);
			default:
				return null;
		}
	};


	return element.type === "itemDetail" ? (
		renderContent()
	  ) : (
		<Draggable
		  key={index}
		  position={{ x: element.x, y: element.y }} // Use the element's position
		  onDrag={(e, { x, y }) => {
			e.stopPropagation();
			handleDrag(x, y);
		  }}
		  disabled={disabledDrag || enableParentDrag !== element.type}
		>
		  <Resizable
			style={{
			  border: `${!disabledDrag ? "2px dotted rgb(202, 207, 191)" : "2px dotted transparent"}`,
			  borderRadius: "10px",
			  position: "relative",
			  padding: "0px 5px 0px 20px" || "",
			  display: "flex",
			  alignItems: "center",
			}}
			size={{ width: element.width, height: element.height }}
			onResizeStop={(e, direction, ref, d) => handleResize(d)}
		  >
			{renderContent()}
		  </Resizable>
		</Draggable>
	  );
};

const processedData = (data, tableHeader, defaultFields, filterState = false, layoutData) => {
	// Get basic details from table headers
	const details = tableHeader?.map((header) => {
	  const basicDetailsSection = layoutData?.find(section => section.checkpointId === "BasicDetails");
	  const layoutField = basicDetailsSection?.fields?.find(f => f.label === header.label);
	  
	  return {
		x: layoutField?.x || 0,
		y: layoutField?.y || 0,
		width: layoutField?.width || 300,
		height: layoutField?.height || 20,
		padding: layoutField?.padding || 5,
		isChecked: layoutField?.isChecked || false,
		label: header.label,
		value: header.type == "date" ? formatDate(findDeepValue(data, header.name.split("."))) : findDeepValue(data, header.name.split(".")),
	  };
	});
  
	// Get status history data
	const newStaticDetail = data?.statusHistory?.map(({ displayName, inTime, outTime, checkpointId }) => {
	  let res = {};
	  const formData = data?.data?.find(item => item.checkpointId === checkpointId)?.formData || {};
	  flattenObj(res, formData);
	  res["inTime"] = inTime;
	  res["outTime"] = outTime;
	  delete res._id;
  
	  const layoutSection = layoutData?.find(section => section.checkpointId === checkpointId);
	  
	  return {
		displayName: displayName,
		checkpointId: checkpointId,
		fields: Object.keys(res).map((fieldName) => {
		  const layoutField = layoutSection?.fields?.find(f => f.label === fieldName);
		  return {
			isChecked: layoutField?.isChecked || false,
			label: fieldName,
			value: res[fieldName],
			x: layoutField?.x || 0,
			y: layoutField?.y || 0,
			width: layoutField?.width || 300,
			height: layoutField?.height || 20,
			padding: layoutField?.padding || 5,
		  };
		})
	  };
	}) || [];
  
	const allField = { 
	  allFields: [
		{ 
		  displayName: "Basic Details", 
		  checkpointId: "BasicDetails", 
		  fields: details 
		}, 
		...newStaticDetail
	  ] 
	};
  
	return filterProcessedData(defaultFields, allField.allFields, filterState);
  };



const filterProcessedData = (defaultData, filteredData, filterState) => {
	// console.log('defaultData====>', defaultData);
	// console.log('filteredData====>', filteredData);
	if (!filterState) {
		return { allFields: filteredData };
	}
	if (defaultData?.length === 0 || defaultData === undefined || defaultData === null) {
		return { allFields: filteredData };
	}
	const result = filteredData.map((ele, index) => {
		const defaultele = defaultData.find((_) => _.checkpointId === ele.checkpointId);
		// console.log('defaultele====>', defaultele);
		const field = ele?.fields.map((_, index) => {
			const defaultField = defaultele?.fields.find((__) => __.label === _.label);
			if (defaultField) {
				_.isChecked = defaultField.isChecked;
			}
			return _;
		});
		return {
			...ele,
			displayName: defaultele?.displayName || ele.displayName,
			fields: field,
		};
	});
	return { allFields: result };
};

const getEncodingData = (data) => {
	// console.log('dynamicDetail====>', data);
	return data;
};

const pepicon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 20 20">
			<g fill="currentColor">
				<path d="M11 6.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0z" opacity="0.2" />
				<path d="M9 15.25a1.25 1.25 0 1 1 2.5 0a1.25 1.25 0 0 1-2.5 0m0-5a1.25 1.25 0 1 1 2.5 0a1.25 1.25 0 0 1-2.5 0m0-5a1.249 1.249 0 1 1 2.5 0a1.25 1.25 0 1 1-2.5 0" />
			</g>
		</svg>
	);
};